import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import completeAdminProfile from 'core/application/companies/completeAdminProfile'
import { getCompleteAdminProfileForSave } from 'core/application/companies/getEmployeeForSave'

import notification from 'common/components/feedback/Notification'

import { ROUTE_PATHS } from 'common/routePaths'

import EditEmployeeForm from '../editEmployeeForm'

type CompleteAdminProfileProps = {}

const CompleteAdminProfile: React.FC<CompleteAdminProfileProps> = () => {
  const history = useHistory()
  const { t: translate } = useTranslation()

  return (
    <EditEmployeeForm
      title={'Complete your profile'}
      disableWorkEmailInput={true}
      submitHandler={(values) => completeAdminProfile(values)}
      overrideGetEmployeeForSaveHandler={(companyUserId) => getCompleteAdminProfileForSave(companyUserId)}
      onSubmitted={() => {
        notification.open({
          message: translate('admin-dashboard.manage-people.edit-profile.employee-update-success'),
          type: 'success',
        })

        history.push(ROUTE_PATHS.DASHBOARD_PATH)
      }}
    />
  )
}
export default CompleteAdminProfile
